import React from 'react';
import { Home, Search, Bookmark, User, Plus, MapPin } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const BottomNav = () => {
  const location = useLocation();
  const { user, isVenue } = useAuth();
  const { t } = useLanguage();

  const navItems = [
    { path: '/discover', icon: Home, label: t('nav_home') },
    { path: '/search', icon: Search, label: t('nav_search') },
    { path: '/map', icon: MapPin, label: t('nav_map') },
    { path: '/saved', icon: Bookmark, label: t('nav_saved') },
    { path: user ? '/profile' : '/login', icon: User, label: t('nav_profile') }
  ];

  // Don't show on landing, login, register, or onboarding pages
  const hideOnPaths = ['/', '/login', '/register', '/onboarding', '/auth/callback'];
  if (hideOnPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass border-t border-[#2C302E]/5 safe-bottom" data-testid="bottom-nav">
      <div className="max-w-md mx-auto px-2">
        <div className="flex items-center justify-around py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || 
              (item.path === '/discover' && location.pathname.startsWith('/activity'));
            
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center py-2 px-4 rounded-xl transition-all duration-200 ${
                  isActive 
                    ? 'text-[#E07A5F]' 
                    : 'text-[#666B67] hover:text-[#2C302E]'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5px]' : ''}`} />
                <span className="text-xs mt-1 font-medium">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>

      {/* Floating action button for venues */}
      {isVenue && (
        <NavLink
          to="/venue/add-activity"
          className="absolute -top-6 left-1/2 -translate-x-1/2 w-14 h-14 bg-[#E07A5F] rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
          data-testid="add-activity-fab"
        >
          <Plus className="w-7 h-7 text-white" />
        </NavLink>
      )}
    </nav>
  );
};

export default BottomNav;
